import React, {Component} from 'react';
import './pScene2.css';
import qs from '../../../Resources/quienes-somos.jpeg';
import {injectIntl} from "react-intl";
import {withRouter} from "react-router";
import {getSpan} from "../../../Utilities/utils";
import BgGrid from "../../BgGrid";
import play from "../../../Resources/icons/play_video_button_normal.svg";

class PScene2 extends Component {
    constructor(props) {
        super(props);
        this.circle_text = React.createRef();
        this.line = React.createRef();
        this.underlined = React.createRef();
    }

    componentDidMount() {
    }

    render() {
        return (
            <section id={'ps2'} className={"p-container"}>
                <div id="pscene2" className={"content"}>
                    <BgGrid className={'p-bg-grid'} id={'p-bg2'}
                        hLines={5} vLines={4}/>
                    <img className={"p_quienes-somos accessibility-img"} src={qs} alt="Quienes Somos"/>
                    <div className={"p_video-container accessibility-img"}>
                        <a onClick={() => this.props.history.push('/manifest/')}>
                        <img src={play} alt={'play'} className={"p_play-circle"} />
                        </a>
                    </div>
                    <h1 id={'ps2txt'} className={'p-text-container-scene-2'} >
                        <span className={"p-text"} >
                            {getSpan(["phome_manifesto_txt","phome_manifesto_txt_1",
                                "phome_manifesto_txt_2"],
                                "p_manifesto_txt",
                                <span> </span>
                            )}
                        </span>
                    </h1>
                </div>
            </section>
        )
    }
}

export default injectIntl(withRouter(PScene2));
